<template>
  <input-base
    :overlap="overlap"
    :small="small"
    :transparent="transparent"
    :stretched="stretched"
    :slimmer="slimmer">

    <label
      slot="label"
      v-if="!!inputLabel"
      :for="getInputName">

      {{ inputLabel }}
    </label>

    <q-icon
      v-if="!!iconLeft"
      slot="icon-left"
      :class="getIconClass"
      :allowSelfUpdate="false"
      width="18px"
      :name="iconLeft" />

    <div
      slot="input"
      slot-scope="{ params }"
      class="rt-options-container">

      <input
        @focus="setCursorLoc"
        type="text"
        :class="`${getInnerStyle} ${extraStyle} ${errorStyle(params)}`"
        :id="identification"
        :name="getInputName"
        :placeholder="getPlaceholderLabel"
        :ref="getInputName"
        :value="value"
        :disabled="disabled"
        @keyup="setValue"
        @change="setValue" />
        
      <rt-options
        @insertEmoji="insertEmoji"
        v-if="rich" />

    </div>
    <q-icon
      v-if="!!iconRight"
      slot="icon-right"
      :class="getIconClass"
      :allowSelfUpdate="false"
      width="18px"
      :name="iconRight" />

  </input-base>
</template>

<script>
import QIcon from '@/components/standard/display/QIcon'
import InputBase from '@/components/standard/input/InputBase'
import RichTextOptions from '@/components/standard/input/RichTextOptions'
import stylers from '@/mixins/components/standard/input/inputButton/stylers'
import '@/assets/styles/standardInputs.css'
import inputValidator from '@/mixins/standard/input/inputValidator'


export default {
  data () {
    return {
      lastCursorLoc: -1,
      updateCursor: true,

      value: this.inputValue || ''
    }
  },

  methods: {
    /**
     * Clears input's value
     */
    clearValue () {
      this.value = ''
    },

    /**
     * Updates input's value
     * @param {Event} e
     */
    setValue (e) {
      if (e.code === 'Enter') {
        this.$emit('submit', {
          submit: true,
          value: this.value
        })
      }

      // If same value is entered (auto complete), don't re run
      if (this.getValueFromInput() === this.value) return

      this.value = this.getValueFromInput()
      this.sendUpdate()
    },

    /**
     * Set's cursor's location
     */
    setCursorLoc () {
      this.$emit("focus", {focused: true})

      this.updateCursor = true
      this.lastCursorLoc = -1
    },

    /**
     * Inserts an emoji
     * @param {Object} e Emoji picker object
     */
    insertEmoji(e) {
      let cursorLocation = this.getInputReference
      let index = cursorLocation.selectionStart
      if (this.updateCursor) {
        this.lastCursorLoc = index
        this.updateCursor = false
      } else {
        // Emoji takes 2 characters.
        this.lastCursorLoc += 2
      }

      index = (this.lastCursorLoc !== -1) ? this.lastCursorLoc : index

      let p1 = this.value.substring(0, index)
      let p2 = this.value.substring(index)
      this.value = `${p1}${e.emoji}${p2}`
      this.sendUpdate()
    }
  },

  computed: {
    /**
     * Gives input's extra styles
     * @returns {String}
     */
    extraStyle () {
      let base = ``
      if (!!this.iconLeft) { base += 'left-padded' }
      return base
    },

    /**
     * Gives icon's classes
     * @returns {String}
     */
    getIconClass () {
      let base = `input-icon`
      if (this.small) base = `${base} adjust-small`
      return base
    },

    /**
     * Gives input's value
     * @returns {String}
     */
    getInputValue () {
      return this.value
    }
  },

  watch: {
    inputValue: function (newValue) {
      this.value = newValue
    }
  },

  components: {
    'rt-options': RichTextOptions,
    'q-icon': QIcon,
    'input-base': InputBase
  },

  props: {
    rich: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  mixins: [
    inputValidator,
    stylers
  ]
}
</script>

<style scoped>
input {
  width: 100%;
  outline: 0;
  background-color: transparent;
}
.tighter {
  padding: 3px 7px;
  font-size: 10px;
  color: #1E1E1E;
  width: auto;
}
.p-holder {
  position: absolute;
  margin-top: 15px;
  font-size: 14px;
  margin-left: 17px;
  transition: margin .3s, font-size .3s;
}
.above {
  margin-top: -15px;
  margin-left: 0px;
  font-size: 10px;
}
.small {
  padding-top: 1px;
  padding-bottom: 1px;
  height: 27px;
  font-size: 12px;
}
.smaller {
  padding-top: 4px;
  padding-bottom: 4px;
  height: 32px;
}
.input-icon.adjust-small {
  position: absolute;
  right: 0;
  bottom: -11px;
}
.extra-rounded {
  border-radius: 14px;
}
.left-padded {
  padding-left: 30px;
}

.transparent {
  color: #353635;
}

</style>




// WEBPACK FOOTER //
// src/components/standard/input/InputText.vue?243638bd